import { render, staticRenderFns } from "./EnrollmentTrendingGraph.vue?vue&type=template&id=1b4550ae&"
import script from "./EnrollmentTrendingGraph.vue?vue&type=script&lang=js&"
export * from "./EnrollmentTrendingGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports